// src/reducers/index.js
import { combineReducers } from 'redux';
import AuthReducer from './auth/authReducer';

const rootReducer = combineReducers({
    authReducer: AuthReducer,
});

export default rootReducer;
